import { render } from "./restaurantOrderCard.vue?vue&type=template&id=b4885aae"
import script from "./restaurantOrderCard.vue?vue&type=script&lang=js"
export * from "./restaurantOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__